import { useTheme, type ThemePref } from "@/lib/theme";

const OPTIONS: { value: ThemePref; label: string; glyph: string }[] = [
  { value: "light", label: "Light theme", glyph: "☀" },
  { value: "dark", label: "Dark theme", glyph: "☾" },
  { value: "system", label: "Match system", glyph: "⌂" },
];

export function ThemeToggle() {
  const { pref, setPref } = useTheme();
  return (
    <div
      className="inline-flex items-center rounded-full border border-neutral-200 p-0.5 text-xs dark:border-neutral-800"
      role="radiogroup"
      aria-label="Theme"
    >
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          role="radio"
          aria-checked={pref === opt.value}
          aria-label={opt.label}
          onClick={() => setPref(opt.value)}
          className={`flex h-7 w-7 items-center justify-center rounded-full transition ${
            pref === opt.value
              ? "bg-neutral-900 text-white dark:bg-neutral-100 dark:text-neutral-900"
              : "text-neutral-500 hover:text-neutral-900 dark:hover:text-neutral-100"
          }`}
        >
          {opt.glyph}
        </button>
      ))}
    </div>
  );
}
